<template>
  <div class="app-right-main">
    <div class="app-right-top-header">
      <el-form
        ref="form"
        inline
        :model="form"
        label-suffix="："
        label-width="auto"
        size="mini"
      >
        <el-form-item prop="mobile">
          <template slot="label">&nbsp;</template>
          <el-input
            class="ml"
            clearable
            placeholder="输入ID、手机号等信息搜索"
            v-model="form.mobile"
            @change="onSubmit"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="国家" prop="nation">
          <el-select
            @change="onSubmit"
            multiple
            size="mini"
            collapse-tags
            filterable
            v-model="form.nation"
            clearable
          >
            <el-option
              v-for="item in country"
              :key="item.EnName"
              :label="item.CnName"
              :value="item.Prefix"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号" prop="unitType">
          <el-select
            clearable
            @change="onSubmit"
            v-model="form.unitType"
            size="mini"
            placeholder="全部"
          >
            <el-option
              v-for="item in devList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select
            clearable
            @change="onSubmit"
            v-model="form.sex"
            size="mini"
            placeholder="全部"
          >
            <el-option
              v-for="item in sexlist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近访问终端" prop="termina">
          <el-select
            clearable
            @change="onSubmit"
            v-model="form.termina"
            size="mini"
            placeholder="全部"
          >
            <el-option
              v-for="item in terminallist"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最后活跃" prop="lastlogin">
          <el-input
            clearable
            placeholder="请输入天"
            size="mini"
            @change="onSubmit"
            v-model="form.lastlogin"
          >
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="注册时间" prop="date">
          <el-date-picker
            clearable
            @change="onSubmit"
            v-model="date"
            type="daterange"
            size="mini"
            :value-format="searchValFormat"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="app-right-table-content">
      <el-table
        v-loading="loading"
        :border="true"
        empty-text="暂无数据"
        :data="tableData"
        stripe
        style="width: 100%"
      >
        <el-table-column align="center" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column align="center" label="ID">
          <template slot-scope="scope">
            {{ scope.row.id || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="国家" width="60">
          <template slot-scope="scope">
            {{ scope.row.Country || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="国家码" width="80">
          <template slot-scope="scope">
            {{ scope.row.Prefix || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="开通会员" width="100">
          <template slot-scope="scope">
            {{ scope.row.VipNames ? scope.row.VipNames.join("、") : "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号" width="110">
          <template slot-scope="scope">
            {{ scope.row.Mobile || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="邮箱">
          <template slot-scope="scope">
            {{ scope.row.Email || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="昵称">
          <template slot-scope="scope">
            {{ scope.row.NickName || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="性别" width="60">
          <template slot-scope="scope">
            {{ scope.row.Gender ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="型号" width="80">
          <template slot-scope="scope">
            {{ scope.row.DeviceType || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备编号">
          <template slot-scope="scope">
            {{ scope.row.DeviceId || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="注册时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.CreateTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="最后活跃时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.LastLogin || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="60">
          <template slot-scope="scope">
            {{ scope.row.Status ? "不可用" : "可用" }}
          </template>
        </el-table-column>
        <el-table-column
          v-permission="'user_detail'"
          align="center"
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <!-- <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            > -->
            <!-- <router-link
              :to="{
                path: '/userDetail',
                query: {
                  id: scope.row.id,
                  tabs: 'first',
                },
              }"
            > -->
            <div
              @click="toUserDetail(scope)"
              style="color: #165dff; cursor: pointer"
            >
              详情
            </div>
            <!-- </router-link> -->
            <!-- </el-button> -->
          </template>
        </el-table-column>
        <!--el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="showAddConfig(scope.$index, tableData)">删除用户
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="resetPwd(scope.$index, tableData)">
              修改密码
            </el-button>
          </template>
        </el-table-column-->
      </el-table>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="pwdDialogVisible"
      @close="closePwdDialog"
    >
      <reset-pwd-form
        :edit-pwd="pwdForm"
        @clickCancel="closePwdDialog"
        @clickConfirm="confirmPwdAction"
      ></reset-pwd-form>
    </el-dialog>
    <div class="dial-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 20, 50, 100, 200, 300, 400]"
        :page-size="size"
        layout="->,sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { users, requestListCountries } from "../../api/userApi";
import { handleResponse } from "../../utils/response";
import { dateFormat } from "../../utils/util";
import ResetPwdForm from "./resetPwdForm";
export default {
  name: "UserManage",
  components: {
    ResetPwdForm,
  },
  data() {
    return {
      loading: false,
      sexlist: [
        {
          key: 1,
          value: 0,
          label: "男",
        },
        {
          key: 2,
          value: 1,
          label: "女",
        },
      ],
      date: [],
      tableData: [{ UserInfo: {} }],
      size: 10,
      page: 1,
      total: 0,
      pwdDialogVisible: false,
      pwdForm: {},
      form: {
        prefix: [],
        nation: [],
      },
      searchValFormat: "yyyy-MM-dd",
      devList: [
        {
          key: 1,
          value: "Y001S",
          label: "Y001S",
        },
        {
          key: 2,
          value: "Y006",
          label: "Y006",
        },
        {
          key: 3,
          value: "Y007",
          label: "Y007",
        },
      ],
      terminallist: [
        {
          key: 1,
          value: "Android",
          label: "安卓",
        },
        {
          key: 2,
          value: "iOs",
          label: "ios",
        },
      ],
      country: [],
    };
  },
  computed: {
    detailFlag() {
      //查看用户详情权限控制
      return (
        this.$store.state.userInfo.permissions.includes("userDetail") ||
        this.$store.getters.isAdmin
      );
    },
  },
  filters: {
    //  typeHand(row){
    //    if(row.DeviceType){
    //      return row.DeviceType
    //    }
    //    var id=row.DeviceId;
    //    if((typeof id )=="string"){
    //      var str =id.slice(0,5)
    //      if(str=="55006"){
    //        return "Y001"
    //      }else if(str=="Y006J" ||str=="Y006Y" ){
    //        return  "Y006"
    //      }else{
    //    return "-"
    //      }
    //    }
    //    return "-"
    //  }
  },
  created() {
    this.requestListCountriesfn();
    this.getUsers();
  },
  watch: {
    date() {
      if (Array.isArray(this.date) && this.date.length == 2) {
        this.form.reg_start = this.date[0];
        this.form.reg_end = this.date[1];
      } else {
        this.form.reg_start = "";
        this.form.reg_end = "";
      }
    },
  },
  methods: {
    toUserDetail(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    async requestListCountriesfn() {
      var countriesList = await requestListCountries();
      this.country = countriesList.data.data.result;
    },
    params() {
      if (Array.isArray(this.date) && this.date.length == 2) {
        this.form.reg_start = this.date[0] + " 00:00:00";
        this.form.reg_end = this.date[1] + " 23:59:59";
      } else {
        this.form.reg_start = "";
        this.form.reg_end = "";
      }
      var prefix = this.form.nation.join(",");
      var params = {
        page: this.page,
        size: this.size,
        keywords: this.form.mobile,
        email: this.form.email,
        // sex: this.form.sex,
        gender: this.form.sex,
        start: this.form.reg_start,
        end: this.form.reg_end,
        lastlogin: this.form.lastlogin,
        agent: this.form.termina,
        prefix,
        deviceType: this.form.unitType,
      };
      return params;
    },
    getUsers() {
      var params = this.params();
      this.loading = true;
      users(params).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.tableData = data.list;
            this.total = data.total * data.size; // total是页数;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getUsers();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    resetPwd(idx, data) {
      this.pwdForm = data[idx];
      this.pwdDialogVisible = true;
    },
    closePwdDialog() {
      this.pwdDialogVisible = false;
    },
    confirmPwdAction() {
      console.log(this.pwdForm.Mobile);
    },
    onSubmit() {
      this.page = 1;
      this.getUsers();
    },
    cancel() {
      window.reload();
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.app-right-main {
  padding: 10px 25px;
  box-sizing: border-box;
  .el-form {
    // padding-top: 20px;
  }

  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
  .dial-pagination {
    padding: 20px;
  }
}
</style>
